import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { pvItems, pvLinks, etItems } from './PrivacyItems'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Index } from '@/components/enlayouts/Legal/Index'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

const sectionTitle = {
  children: (
    <>
      <h2>
        Privacy Policy
        <br />
        {/* <span>（プライバシーポリシー）</span> */}
      </h2>
    </>
  ),
}


const secondsectionTitle = {
  children: (
    <>
      <h2>
      External Transmission of User Information
      </h2>
    </>
  ),
}


const tSummary = (
  <p>
    TRIAL Holdings, Inc. and its group companies *(hereinafter referred to as &quot;TRIAL Group&quot;), in order for customers, business partners, applicants for employment, and shareholders (hereinafter collectively referred to as the &quot;Customers&quot;) to use TRIAL Group&apos;s stores, websites, mobile applications and services (hereinafter referred to as the &quot;Websites&quot;) with peace of mind, shall comply with the Act on the Protection of Personal Information, its related laws, regulations, and guidelines (hereinafter referred to as the &quot;Personal Information Protection Acts&quot;) and manage the personal information of the Customers with the utmost care. TRIAL Group has established this Privacy Policy (hereinafter referred to as the &quot;Privacy Policy&quot;) as its basic policy for the handling of personal information and shall strive to handle the personal information of the Customers collected by TRIAL Group in a legal and appropriate manner. In addition, the Customers using the Websites are deemed to have agreed to the Privacy Policy.
    <br />
    * &quot;TRIAL Group&quot; shall mean TRIAL Holdings, Inc., together with  its consolidated subsidiaries and affiliates accounted for under the equity method, excluding SU-PAY Co., Ltd.  The privacy policy applicable to SU-PAY Co., Ltd. shall be separately stipulated.
    <br />
    This Privacy Policy does not apply to SU-PAY Co., Ltd. and SEIYU Net Supermarket service.
    <br />
    *Click <a href="https://su-pay.jp/prepaid/terms/" target="_blank" rel="noreferrer">here</a> for the privacy policy of SU-PAY Co., Ltd.
    <br />
    *Click <a href="https://netsuper.rakuten.co.jp/seiyu/info/privacy/" target="_blank" rel="noreferrer">here</a> for the privacy policy of SEIYU Net Super.
  </p>
)

export const PrivacyPage = () => {
  return (
    <>
      <Head
        title="Privacy Policy"
        description="The privacy policy for TRIAL Holdings, Inc."
        ogp={{ type: 'article', url: 'en/legal/privacy-policy/' }}
      />
      <PrivacyContainer>
        <SectionTitle {...sectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 46, sp: 35 }} />
        <Index columnGap={84} listType="article" links={pvLinks} />
        <Spacer h={{ pc: 35, sp: 40 }} />
        {pvItems.map(({ children, id }, index, array) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < array.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}


        {/* secondsectionTitleを追加 */}
        <Spacer h={{ pc: 100, sp: 60 }} />
        <SectionTitle {...secondsectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />

        {etItems.map(({ children, id }, index, array) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < array.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </PrivacyContainer>
    </>
  )
}
PrivacyPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Privacy Policy', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const PrivacyContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }

  #privacy7 {
    margin-top: -105px;
    padding-top: 105px;
  }

  @media screen and (max-width: 1047px) {
    #privacy7 {
      margin-top: -53px;
      padding-top: 53px;
    }
  }
`

